export const toastConstants = {
  SUCCESS_TIMEOUT: 1500,
  INFO_TIMEOUT: 3000,
  ERROR_TIMEOUT: 5000,
  WARNING_TIMEOUT: 10000,
  NOTICE_TIMEOUT: 20000
};
